{
    "CancelChange": "Cancel",
    "ConfirmChange": "Confirm",
    "Detailstitle": "Call Segment Details",
    "Recordingtitle": "Call Segment Recording",
    "Details": "Details",
    "Recording": "Recording",
    "Value": "Value",
    "Collapseall": "Collapse All",
    "FieldStatistic": "Field / Statistic",
    "Calldatetimevalues": "Call Date / Time Values",
    "Deviceinformation": "Device Information",
    "Calltypestatus": "Call Type & Status",
    "Callmovement": "Call Movement Scenario Information",
    "Calldurationvalues": "Call Duration Values",
    "Telephoneinformation": "Telephone Number Information",
    "Acdinformation": "ACD Agent Information",
    "Associatedtelephonyenvironment": "Associated Telephony Environment",
    "Diagnosticvalues": "Diagnostic Values",
    "Previous": "Previous",
    "Next": "Next",
    "First": "First",
    "Last": "Last",
    "Playrecording": "Play Recording",
    "Errorplayrecording": "Recording Retrieval Failed",
    "Norecording": "No Recording(s)",
    "Retrievingrecordings": "Retrieving Recordings...",
    "Backtodetails": "Back to Details",
    "Segmentid": "Copy Segment Chain ID",
    "Copied": "Copied!",
    "Help": "Help",
    "Close": "Close",
    "RecordingTimeoutError": "Maximum number of attempts to get the call recordings for this call was exceeded.",
    "AccountCodeHint": "Click the account code to edit this field.",
    "AccountCodePlaceholder": "Click here to add account code",
    "DescriptionHint": "Click the description to edit this field.",
    "DescriptionPlaceholder": "Click here to add description",
    "ReloadDataP1": "An entry was recently updated, ",
    "ReloadDataP2": "click here ",
    "ReloadDataP3": "to reload the data.",
    "DescMaxLengthValidation": "There is a max character length of 100.",
    "NAME": "CallDetails",
    "NoAccountCodes": "No account codes available",
    "CallJourneyTitle": "Call Journey",
    "CallRecordingTitle": "Call Recording",
    "CallSegmentTitle": "Segment {} of {}",
    "TabTextTimeline": "Timeline",
    "TabTextSegments": "Segments",
    "TabTextRecording": "Recording",
    "StatisticDeviceCalled": "Called Name/Number",
    "StatisticDeviceCalling": "Calling Name/Number",
    "StatisticTotalCallTime": "Total Call Time",
    "StatisticTotalCallTimeInProgress": "Call in Progress",
    "StatisticStatus": "Status",
    "Answered": "Answered",
    "NotAnswered": "Not answered"
}
